APP.isMobile = function () {
  if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i)) return true;
  else return false;
};

APP.isTablet = function () {
  if (navigator.userAgent.match(/Tablet|iPad/i)) return true;
  else return false;
};

APP.isDesktop = function () {
  if (!APP.isMobile() && !APP.isTablet()) return true;
  else return false;
};

APP.isLandscape = function () {
  if (window.innerHeight < window.innerWidth) return true;
  else return false;
};

APP.resize = function (func, timer) {
  let resizeEnd;
  timer = timer || 150;
  window.addEventListener('resize', function () {
    clearTimeout(resizeEnd);
    resizeEnd = setTimeout(func, timer);
  });
};

APP.getResize = function () {
  WIN_WIDTH = WINDOW.width();
  WIN_HEIGHT = WINDOW.height();
  DOC_WIDTH = DOCUMENT.width();
  DOC_HEIGHT = DOCUMENT.height();
};

APP.setScrollTopAnimation = function (posY , duration) {
  if (duration === undefined) {
    duration = 1;
  }
  TweenMax.to(WINDOW, duration, {
    scrollTo: {
      y: posY,
      autoKill: false
    },
    ease: Power0.easeNone
  });
};

APP.getScrollTop = function () {
  return WINDOW.scrollTop();
};

APP.setCookie = function (key, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
};

APP.getCookie = function (key) {
  const keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
};

APP.removeCookie = function (key) {
  APP.setCookie(key, '', -1);
};

APP.getScrollbarWidth = function () {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
};

APP.isInViewport = function (element) {
  let elementTop = $(element).offset().top;
  let elementBottom = elementTop + $(element).outerHeight();

  let viewportTop = $(window).scrollTop();
  let viewportBottom = viewportTop + $(window).height() / 2;

  return elementTop < viewportBottom && elementBottom > viewportBottom;
};

APP.clamp = function (val, min = 0, max = 1) {
  return Math.max(min, Math.min(max, val));
},

APP.map = function (value, min1, max1, min2, max2) {
  return min2 + (max2 - min2) * (value - min1) / (max1 - min1);
};

APP.getRatio = function ({ x: w, y: h }, { width, height }, r = 0) {
  const m = APP.multiplyMatrixAndPoint(APP.rotateMatrix(THREE.Math.degToRad(r)), [w, h])
  const originalRatio = {
    w: m[0] / width,
    h: m[1] / height,
  }

  const coverRatio = 1 / Math.max(originalRatio.w, originalRatio.h)

  return new THREE.Vector2(
    originalRatio.w * coverRatio,
    originalRatio.h * coverRatio,
  )
};

APP.rotateMatrix = function (a) {
  return [Math.cos(a), -Math.sin(a), Math.sin(a), Math.cos(a)];
};

APP.multiplyMatrixAndPoint = function (matrix, point) {
  const c0r0 = matrix[0]
  const c1r0 = matrix[1]
  const c0r1 = matrix[2]
  const c1r1 = matrix[3]
  const x = point[0]
  const y = point[1]
  return [Math.abs(x * c0r0 + y * c0r1), Math.abs(x * c1r0 + y * c1r1)]
};

APP.wrap = function (el, wrapper) {
  el.parentNode.insertBefore(wrapper, el)
  wrapper.appendChild(el)
};

APP.unwrap = function (content) {
  for (let i = 0; i < content.length; i++) {
    const el = content[i]
    const parent = el.parentNode

    if (parent.parentNode) parent.outerHTML = el.innerHTML
  }
};

APP.ev = function (eventName, data, once = false) {
  const e = new CustomEvent(eventName, { detail: data }, { once })
  document.dispatchEvent(e)
};

APP.lerp = (a, b, n) => (1 - n) * a + n * b;

APP.getMousePos = e => {
  return {
    x : e.clientX,
    y : e.clientY
  };
};